import React, { useState, ReactNode } from "react";
import TopBar from "../TopBar";
import Sidebar, { SidebarItem } from "../Sidebar";

interface Props {
    navItems: SidebarItem[];
    children: ReactNode;
}

export default function Layout({ navItems, children }: Props) {
    const [open, setOpen] = useState(false);

    return (
        <div className="flex h-screen flex-col bg-surface font-sans text-ink">
            <TopBar onToggleSidebar={() => setOpen((v) => !v)} />
            <Sidebar items={navItems} isOpen={open} onClose={() => setOpen(false)} />
            <main
                className={[
                    "flex min-h-0 flex-1 flex-col overflow-hidden bg-surface-2",
                    open ? "lg:pl-60" : "lg:pl-[72px]",
                ].join(" ")}
            >
                {children}
            </main>
        </div>
    );
}
